module.exports = __webpack_public_path__ + "img/refresh.cefe7c25.svg";